import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/css/css.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/attributes/prop/prop.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/core/each/each.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/events/trigger/trigger.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/traversal/closest/closest.js";

const selectsearch = "form__control-selectsearch",
	empty = value => ["", "0", null, undefined].includes(value);

/**
 * Reads the label of the item selected in a source control
 *
 * @param {Dabby} source The source control
 * @returns {?string} The label of the selected item, or null when nothing is selected
 */
const getSelectedLabel = source => {
	const node = source[0],
		type = node.nodeName;
	let label = null;

	// select controls compare option value, fieldset contains labels and checkboxes, both must be a single selection
	if (["SELECT", "FIELDSET"].includes(type)) {
		const select = type === "SELECT",
			value = $((select ? "option" : "input") + ":checked", source);
		if (value.length === 1 && !empty(value.attr("value"))) {
			label = (select ? value : $("label[for='" + value.attr("id") + "']", source)).text().trim();
		}

	// selectsearch keeps its value in a hidden input, with the label rendered as a sibling
	} else if (!empty(source.val())) {
		label = $("." + selectsearch + "-label", source.closest("." + selectsearch)).text().trim();
	}
	return label;
};

export default obj => {
	obj.each(function () {
		const source = $(this),
			target = $("#" + source.data("filter"));

		if (target.length) {
			const node = target[0],
				select = node.nodeName === "SELECT",

				// init denotes the run on page load, where the value the target already holds must be left alone
				update = (init = false) => {
					const label = getSelectedLabel(source);

					// selectsearch only renders part of its dataset, so it has to filter on the server
					if (node.nodeName === "INPUT") {

						// on load there is nothing to do without a selection, the whole dataset is already rendered
						if (!init || label !== null) {
							target.closest("." + selectsearch)
								.data("group", label === null ? "" : label)
								.trigger("filtered", [!init]);
						}

					// show only the groups containing the selected label, or all of them when nothing is selected
					} else {
						target.children(select ? "optgroup" : "fieldset").each(function () {
							const group = $(this),
								name = select ? group.attr("label") : $("legend", group).text().trim();
							group.css("display", label !== null && !(name || "").includes(label) ? "none" : "");
						});

						// the selected value may not be in the filtered groups, but don't clear a value the user hasn't changed
						if (!init) {
							if (select) {
								target.val("");
							} else {
								$("input:checked", target).prop("checked", false);
							}
						}
					}
				};

			// update onload, change passes the event as the first argument so update cannot be bound directly
			source.on("change", () => update());
			update(true);
		}
	});
}
